import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const issueNavigatorProjectBusinessCustomEmbedRoute: InvariantJiraRoute = {
	name: 'issue-navigator-core-custom-embed',
	path: '/jira/core/projects/:projectKey/issues/:navigationItemId/embed',
};
